export const FLEET_DETAIL_START = "FLEET_DETAIL_START"
export const FLEET_DETAIL_SUCCESS = "FLEET_DETAIL_SUCCESS"
export const FLEET_DETAIL_ERROR= "FLEET_DETAIL_ERROR"

export const DOCUMENT_EXPIRED_START = "DOCUMENT_EXPIRED_START"
export const DOCUMENT_EXPIRED_SUCCESS = "DOCUMENT_EXPIRED_SUCCESS"
export const DOCUMENT_EXPIRED_ERROR= "DOCUMENT_EXPIRED_ERROR"